<div>
    <button class="no-border file-upload-open"
            mat-stroked-button
            title="Dodaj dokument"
            (click)="onClick()">
        <mat-icon>folder</mat-icon>
        Dodaj dokument
    </button>

    <input
            class="d-none"
            type="file"
            #fileUpload
            id="fileUpload"
            multiple="multiple"
            (change)="upload($event)"/>
    <ul class="list-group"
        *ngFor="let file of files" >
        <li class="list-group-item no-border no-padding">
            <div class="col-md-12 no-margin" style="border-radius: 2%;padding: 10px 0 10px;color: #188bfa;">
                <div class="col-md-1 no-padding">
                    <img style="height: 32px;width: 32px;border: 2px solid #fff;
border-radius: 12%;" src="assets/icons/icon11.png">
                </div>
                <div class="col-md-10" style="word-break: break-word;
margin-top: 6px;
font-size: 11px;
padding-left: 0;">
                    {{file.real_name}}
                </div>
                <div class="col-md-1" style="padding-right: 0;cursor: pointer">
                    <mat-icon (click)="remove(file)" style="float: right;margin-top: 9px;color:#80808054"
                              aria-hidden="false"
                              title="Obriši dokument">
                        delete
                    </mat-icon>
                </div>


            </div>
        </li>
    </ul>
</div>

